<template>
  <div class="phone" :class="{ 'phone--compact': compact }">
    <div class="phone__frame">
      <div class="phone__notch"></div>
      <div class="phone__screen">
        <div class="phone__status">
          <span>09:41</span>
          <span class="phone__status-icons">
            <i class="fa fa-signal"></i>
            <i class="fa fa-wifi"></i>
            <i class="fa fa-battery-three-quarters"></i>
          </span>
        </div>
        <AppScreen :screen="screen" />
      </div>
    </div>
  </div>
</template>

<script>
import AppScreen from "./AppScreen";

export default {
  name: "PhoneMockup",
  components: { AppScreen },
  props: {
    screen: { type: String, required: true },
    compact: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="scss">
.phone {
  width: 290px;
  flex-shrink: 0;
}

.phone__frame {
  position: relative;
  padding: 10px;
  border-radius: 44px;
  background: linear-gradient(160deg, #3a1d52, #12061f);
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.08) inset,
    0 30px 70px rgba(10, 2, 20, 0.55),
    0 8px 20px rgba(10, 2, 20, 0.35);
}

.phone__notch {
  position: absolute;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  width: 90px;
  height: 24px;
  border-radius: 20px;
  background: #0b0313;
  z-index: 3;
}

.phone__screen {
  position: relative;
  height: 600px;
  border-radius: 34px;
  overflow: hidden;
  background: #f6f3f9;
  display: flex;
  flex-direction: column;
  font-family: "Inter", sans-serif;
  line-height: 1.35;
  text-align: left;
}

.phone__status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 26px 6px;
  font-size: 11px;
  font-weight: 700;
  color: #1a0a2e;
  background: #fff;
  flex-shrink: 0;
}

.phone__status-icons {
  display: flex;
  gap: 5px;
  font-size: 10px;
}

.phone--compact {
  width: 250px;

  .phone__screen {
    height: 520px;
  }
}
</style>
